import { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import BYDBanner from './Asset/banner-DenzaD9.webp';
import BYDBannerMobile from './Asset/denzad9-banner-mob.webp';
import DenzaD9Black from './Asset/Denza_D9_EV-black.webp';
import DenzaD9White from './Asset/Denza_D9_EV-white.webp';
import DenzaD9Grey from './Asset/Denza_D9_EV-grey.webp';
import DenzaD9Blue from './Asset/Denza_D9_EV-blue.webp';
import DenzaD9Interior from './Asset/interior.webp';
import DenzaD9Sunroof from './Asset/m07-pc-skylight.webp';
import DenzaD9beige from './Asset/interior-beige.webp';
import DenzaD9brown from './Asset/interior-brown.webp';
import { Helmet } from 'react-helmet-async';

function JelajahiDenza() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [selectedColor, setSelectedColor] = useState('black');
  const [selectedInterior, setSelectedInterior] = useState('beige');

  const colorOptions = [
    { label: 'Black', color: 'black', image: DenzaD9Black },
    { label: 'White', color: 'white', image: DenzaD9White },
    { label: 'Grey', color: 'grey', image: DenzaD9Grey },
    { label: 'Blue', color: 'darkblue', image: DenzaD9Blue },
  ];

  const interiorOptions = [
    { label: 'Beige', color: 'beige', image: DenzaD9beige },
    { label: 'Brown', color: 'brown', image: DenzaD9brown },
  ];

  const currentImage = colorOptions.find(
    (option) => option.color === selectedColor,
  )?.image;
  const currentInteriorImage = interiorOptions.find(
    (option) => option.color === selectedInterior,
  )?.image;

  const images = [
    {
      src: isMobile ? BYDBannerMobile : BYDBanner,
      title: 'A Luxurious New Energy Vehicle DENZA D9',
      specs: [
        { value: '520 km', label: 'WLTC all-electric range' },
        { value: '150 km', label: '10-minute-charge range' },
        { value: '6.9s', label: '0-100km/h acceleration' },
      ],
    },
    {
      src: currentImage,
      customContent: (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 3,
            flexWrap: 'wrap',
            px: 2,
            py: 1.5,
            borderRadius: 2,
            backgroundColor: 'rgba(255,255,255,0.9)',
            boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
            width: 'fit-content',
            maxWidth: '95%',
          }}
        >
          {colorOptions.map((option) => (
            <Box
              key={option.color}
              onClick={() => setSelectedColor(option.color)}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                cursor: 'pointer',
                minWidth: 64,
              }}
            >
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  backgroundColor: option.color,
                  borderRadius: '50%',
                  border:
                    selectedColor === option.color
                      ? '2px solid #000'
                      : '2px solid #ddd',
                  marginBottom: 1,
                }}
              />
              <Typography
                variant='body2'
                sx={{
                  color: '#111',
                  fontWeight: 600,
                  lineHeight: 1.2,
                }}
              >
                {option.label}
              </Typography>
            </Box>
          ))}
        </Box>
      ),
    },
    {
      src: currentInteriorImage,
      title: `Interior Color: ${
        interiorOptions.find((option) => option.color === selectedInterior)
          ?.label
      }`,
      customContent: (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 3,
            flexWrap: 'wrap',
            px: 2,
            py: 1.5,
            borderRadius: 2,
            backgroundColor: 'rgba(255,255,255,0.9)',
            boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
            width: 'fit-content',
            maxWidth: '95%',
          }}
        >
          {interiorOptions.map((option) => (
            <Box
              key={option.color}
              onClick={() => setSelectedInterior(option.color)}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                cursor: 'pointer',
                minWidth: 64,
              }}
            >
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  backgroundColor:
                    option.color === 'beige' ? '#F5F5DC' : '#8B4513',
                  borderRadius: '50%',
                  border:
                    selectedInterior === option.color
                      ? '2px solid #000'
                      : '2px solid #ddd',
                  marginBottom: 1,
                }}
              />
              <Typography
                variant='body2'
                sx={{
                  color: '#111',
                  fontWeight: 600,
                  lineHeight: 1.2,
                }}
              >
                {option.label}
              </Typography>
            </Box>
          ))}
        </Box>
      ),
    },
    {
      src: DenzaD9Sunroof,
      title: 'Sunroof: Pandangan Luas',
      description: `Sunroof panoramik ekstra besar kami menghadirkan cahaya alami, membuat kabin terasa terang dan lapang, dilengkapi dengan kaca dua lapis yang mampu memblokir 99% sinar UV.`,
    },
    {
      src: DenzaD9Interior,
      description: `Gambar di atas hanya untuk referensi. Semua perlengkapan mengikuti spesifikasi aktual model setir kanan untuk Indonesia.`,
    },
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>BYD Denza D9 - Dealer Resmi di BSD Serpong</title>
        <meta
          name='description'
          content='Temukan BYD Denza D9 di Dealer Resmi BYD BSD Serpong. Dapatkan promo terbaik untuk mobil listrik di lokasi Anda!'
        />
        <meta
          name='keywords'
          content='BYD Denza D9 BSD Serpong, Dealer Mobil Listrik BSD Serpong, Harga BYD Denza D9 Serpong, BYD BSD Serpong'
        />
        <meta name='author' content='BYD BSD Serpong Junius' />
        <meta name='geo.region' content='ID-BT' />
        <meta
          name='geo.placename'
          content='BSD Serpong, Tangerang Selatan, Indonesia'
        />
        <meta name='geo.position' content='-6.3046;106.6496' />
        <meta name='ICBM' content='-6.3046, 106.6496' />
        <script type='application/ld+json'>
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Product',
            name: 'BYD Denza D9',
            image:
              'https://bydbsdserpong.com/static/media/banner-DenzaD9.2542005342edf9f85567.webp',
            description:
              'SUV listrik terbaru dengan performa tinggi, dirancang oleh Wolfgang Egger.',
            brand: {
              '@type': 'Brand',
              name: 'BYD',
            },
            offers: {
              '@type': 'Offer',
              price: 950000000,
              priceCurrency: 'IDR',
              priceValidUntil: '2025-12-31',
              availability: 'https://schema.org/InStock',
              url: 'https://bydbsdserpong.com',
            },
            aggregateRating: {
              '@type': 'AggregateRating',
              ratingValue: 4.8,
              reviewCount: 72,
            },
            review: [
              {
                '@type': 'Review',
                author: {
                  '@type': 'Person',
                  name: 'Junius',
                },
                datePublished: '2025-01-01',
                reviewBody:
                  'The BYD Denza D9 is an excellent electric car with great features!',
                reviewRating: {
                  '@type': 'Rating',
                  ratingValue: 5,
                  bestRating: 5,
                },
              },
              {
                '@type': 'Review',
                author: {
                  '@type': 'Person',
                  name: 'Sarah',
                },
                datePublished: '2025-01-05',
                reviewBody:
                  'Comfortable, eco-friendly, and stylish. Highly recommend this vehicle.',
                reviewRating: {
                  '@type': 'Rating',
                  ratingValue: 4.5,
                  bestRating: 5,
                },
              },
            ],
          })}
        </script>
      </Helmet>

      <Box
        component='h1'
        sx={{
          position: 'absolute',
          width: 1,
          height: 1,
          p: 0,
          m: -1,
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          border: 0,
        }}
      >
        Jelajahi BYD Denza D9
      </Box>
      <Box>
        {images.map((img, index) => (
          <Box
            key={index}
            sx={{
              position: 'relative',
              height: '100vh',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
              isolation: 'isolate',
              backgroundColor: '#000',
            }}
          >
            <Box
              component='img'
              src={img.src}
              alt={img.title || `Image ${index + 1}`}
              sx={{
                position: 'absolute',
                inset: 0,
                margin: 'auto',
                zIndex: 1,
                ...(isMobile
                  ? ['DenzaD9Sunroof', 'DenzaD9Interior'].some((name) =>
                      img.src.includes(name),
                    )
                    ? {
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }
                    : [
                          'DenzaD9beige',
                          'DenzaD9brown',
                          'DenzaD9Black',
                          'DenzaD9White',
                          'DenzaD9Grey',
                          'DenzaD9Blue',
                        ].some((name) => img.src.includes(name))
                      ? {
                          width: '100%',
                          height: '70%',
                          objectFit: 'contain',
                        }
                      : {
                          width: '100%',
                          height: '100%',
                          objectFit: 'contain',
                        }
                  : {
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                    }),
              }}
            />

            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                zIndex: 2,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
                px: { xs: 2, sm: 4 },
                py: { xs: 3, sm: 5 },
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  textAlign: 'center',
                }}
              >
                {img.title && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: { xs: '80px', sm: '95px' },
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      px: 2,
                      zIndex: 3,
                    }}
                  >
                    <Typography
                      variant='h4'
                      fontWeight='bold'
                      sx={{
                        color: '#fff',
                        fontSize: { xs: '1.25rem', sm: '2rem', md: '2.5rem' },
                        px: 2,
                        py: 1,
                        borderRadius: 2,
                        backgroundColor: 'rgba(0,0,0,0.45)',
                        maxWidth: '90%',
                        textAlign: 'center',
                      }}
                    >
                      {img.title}
                    </Typography>
                  </Box>
                )}
              </Box>

              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                {img.specs && (
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom:
                        index === 0
                          ? { xs: '52px', sm: '72px' }
                          : { xs: '15%', sm: '10%' },
                      left: '50%',
                      transform: 'translateX(-50%)',
                      display: 'flex',
                      flexDirection: { xs: 'column', sm: 'row' },
                      justifyContent: 'center',
                      gap: 2,
                      color: '#fff',
                      px: 2,
                      py: 1.5,
                      borderRadius: 2,
                      backgroundColor: 'rgba(0,0,0,0.45)',
                      width: 'fit-content',
                      maxWidth: '92%',
                      zIndex: 3,
                    }}
                  >
                    {img.specs.map((spec, i) => (
                      <Box key={i}>
                        <Typography
                          variant='h6'
                          fontWeight='bold'
                          sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}
                        >
                          {spec.value}
                        </Typography>
                        <Typography
                          variant='body2'
                          sx={{ fontSize: { xs: '0.9rem', sm: '1rem' } }}
                        >
                          {spec.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                )}

                {img.description && (
                  <Box
                    sx={{
                      color: '#fff',
                      textAlign: 'center',
                      px: 2,
                      py: 1.5,
                      borderRadius: '8px',
                      backgroundColor: 'rgba(0, 0, 0, 0.5)',
                      maxWidth: { xs: '95%', sm: '75%' },
                    }}
                  >
                    <Typography
                      variant='body1'
                      sx={{
                        fontSize: { xs: '0.9rem', sm: '1rem' },
                        lineHeight: 1.6,
                      }}
                    >
                      {img.description}
                    </Typography>
                  </Box>
                )}

                {img.customContent && (
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      '& > *': {
                        width: '100%',
                      },
                    }}
                  >
                    {img.customContent}
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        ))}
        <Box
          sx={{
            padding: { xs: 3, sm: 6 },
            backgroundColor: '#f5f5f5',
            textAlign: 'center',
          }}
        >
          <Typography
            variant='h2'
            sx={{
              fontSize: { xs: '1.5rem', sm: '2rem' },
              fontWeight: 600,
              mb: 2,
            }}
          >
            Tertarik dengan Denza D9?
          </Typography>
          <Typography variant='body1' sx={{ mb: 3 }}>
            Dapatkan info lengkap dan promo terbaru{' '}
            <strong>Harga BYD Atto1</strong> hanya di{' '}
            <strong>BYD BSD Serpong</strong>. Kami juga menyediakan informasi
            lengkap tentang <strong>Harga Denza D9</strong>,{' '}
            <strong>Harga Sealion 7</strong>, dan <strong>Harga Atto1</strong>{' '}
            langsung dari dealer resmi.
          </Typography>
          <Button
            href='https://api.whatsapp.com/send?phone=6281286864825&text=Halo%20saya%20tertarik%20dengan%20BYD%20DenzaD9%20dan%20ingin%20tahu%20harganya'
            target='_blank'
            variant='contained'
            color='primary'
          >
            Tanya Harga Sekarang
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default JelajahiDenza;
